module.exports = require('./helpers/bundle-url').getBundleURL('ivTf3') + "search-error.7deca030.svg";